import { render } from "./ButtonsGroup.vue?vue&type=template&id=9383831c&scoped=true"
import script from "./ButtonsGroup.vue?vue&type=script&lang=js"
export * from "./ButtonsGroup.vue?vue&type=script&lang=js"

import "./ButtonsGroup.vue?vue&type=style&index=0&id=9383831c&lang=scss&scoped=true"

import exportComponent from "/proyectos/programas-de-investigacion/scga-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9383831c"]])

export default __exports__